import { render, staticRenderFns } from "./QueryChocostickT.vue?vue&type=template&id=7883f72b&"
import script from "./QueryChocostickT.vue?vue&type=script&lang=js&"
export * from "./QueryChocostickT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports